import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faPhone, faLocationDot } from "@fortawesome/free-solid-svg-icons";
import { useLanguage } from "../../../Context/LanguageContext";
import "../legal/LegalPage.css";
import "./ContactUs.css";

export default function ContactUs ()
{
    const { lang } = useLanguage();
    const isAr = lang === "ar";

    return (
        <div className="legal-page">
            <div className="legal-container">
                <h1 className="legal-title">
                    { isAr ? "تواصل معنا" : "Contact Us" }
                </h1>
                <p className="legal-updated">
                    { isAr
                        ? "يسعدنا تواصلك معنا لأي استفسار أو مساعدة"
                        : "We'd love to hear from you for any questions or support" }
                </p>

                <div className="contact-info-grid">
                    <div className="contact-info-card">
                        <FontAwesomeIcon icon={ faEnvelope } />
                        <h3>{ isAr ? "البريد الإلكتروني" : "Email" }</h3>
                        <a href="mailto:support@yourstore.com">saleemalfarhany@gmail.com</a>
                    </div>
                    <div className="contact-info-card">
                        <FontAwesomeIcon icon={ faPhone } />
                        <h3>{ isAr ? "الهاتف" : "Phone" }</h3>
                        <a
                            href="https://wa.me/967771949015"
                            target="_blank"
                            rel="noopener noreferrer"
                            dir="ltr"
                        >
                            +967771949015
                        </a>
                    </div>
                    <div className="contact-info-card">
                        <FontAwesomeIcon icon={ faLocationDot } />
                        <h3>{ isAr ? "العنوان" : "Address" }</h3>
                        <span>{ isAr ? "[سليم الشرعبي]" : "[saleem alsharabi]" }</span>
                    </div>
                </div>

                <div className="legal-contact-box">
                    <p style={ { margin: 0, fontSize: "13.5px", color: "#8890a0" } }>
                        { isAr
                            ? "أوقات الرد على الاستفسارات: من الأحد إلى الخميس، 9 صباحًا - 6 مساءً"
                            : "Response hours: Sunday to Thursday, 9 AM - 6 PM" }
                    </p>
                </div>
            </div>
        </div>
    );
}
